(function () {
  "use strict";

  function money(cents, currency) {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || "es-ES", {
        style: "currency",
        currency: currency || "EUR",
      }).format(Number(cents || 0) / 100);
    } catch (_error) {
      return (Number(cents || 0) / 100).toFixed(2) + " €";
    }
  }

  function shopPath(path) {
    var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root;
    return (root || "/") + path.replace(/^\//, "");
  }

  function publishVexa(name, data) {
    // Shopify routes these events to the consent-managed pixel sandbox.
    try {
      if (window.Shopify && window.Shopify.analytics && window.Shopify.analytics.publish) {
        window.Shopify.analytics.publish(name, data);
      }
    } catch (_error) { /* Analytics must never block a purchase. */ }
  }

  // Meta Pixel runs directly in the theme so browser helpers can detect it.
  // Keep tracking best-effort: analytics must never block a purchase.
  function metaTrack(name, data, eventId) {
    try {
      if (typeof window.fbq !== "function") return;
      var params = data || {};
      if (eventId) window.fbq("track", name, params, { eventID: eventId });
      else window.fbq("track", name, params);
    } catch (_error) { /* Meta tracking must never block a purchase. */ }
  }

  function setStatus(element, message, type) {
    if (!element) return;
    element.textContent = message;
    element.className = "vc-form-status is-visible " + (type === "success" ? "is-success" : "is-error");
  }

  function initVexaPage(page) {
    var productScript = page.querySelector("[data-vexa-product]");
    var product = null;
    if (productScript) {
      try {
        product = JSON.parse(productScript.textContent);
      } catch (_error) {
        product = null;
      }
    }

    if (page.dataset.vexaInitialized === "true") return;
    page.dataset.vexaInitialized = "true";
    var kits = product && product.kits ? product.kits : {};
    var state = {
      quantity: 1,
      lineQuantity: 1,
      submitting: false,
      onlineRedirecting: false,
      created: false,
      requestId: "",
      unitPrice: Number(page.dataset.unitPrice || 2999),
      comparePrice: Number(page.dataset.comparePrice || 5499),
      currency: page.dataset.currency || "EUR",
      specialRegion: page.dataset.vexaSpecialRegion === "true",
      variantId: product && product.variant_id ? String(product.variant_id) : "",
      directCod: page.dataset.directCod === "true",
      endpoint: page.dataset.codEndpoint || "/apps/gervix-cod/order",
      countryCode: (page.dataset.countryCode || "ES").toUpperCase(),
    };

    var drawer = page.querySelector("[data-cod-drawer]");
    var form = page.querySelector("[data-cod-form]");
    var couponInput = form && form.querySelector("[data-cod-discount]");
    var couponStatus = form && form.querySelector("[data-cod-discount-status]");
    var appliedDiscount = null;
    var status = page.querySelector("[data-form-status]");
    var formView = page.querySelector("[data-cod-form-view]");
    var successState = page.querySelector("[data-success-state]");
    var successMessage = page.querySelector("[data-success-message]");
    var lastFocused = null;
    var lockedScrollY = 0;
    /* VEXA regional final-price display v1 */
    function kitDisplayPrice(quantity) {
      var kit = kits[String(quantity)];
      if (state.specialRegion) {
        var regionalTotals = { "1": 4499, "2": 6999, "3": 7999 };
        return regionalTotals[String(quantity)] || (kit ? Number(kit.price || 0) : state.unitPrice * Number(quantity || 1));
      }
      return kit ? Number(kit.price || 0) : state.unitPrice * Number(quantity || 1);
    }

    /* VEXA COD interaction hardening v1 */
    function setCodBusy(busy) {
      state.submitting = busy;
      if (!drawer) return;
      drawer.setAttribute("aria-busy", busy ? "true" : "false");
      drawer.querySelectorAll("[data-cod-submit], [data-online-checkout], [data-cod-close], [data-quantity]").forEach(function (control) {
        if (busy) {
          control.dataset.vexaBusyDisabled = control.disabled ? "preserve" : "temporary";
          control.disabled = true;
        } else {
          if (control.dataset.vexaBusyDisabled === "temporary") control.disabled = false;
          delete control.dataset.vexaBusyDisabled;
        }
      });
      if (!busy) chooseQuantity(state.quantity);
    }

    function kitComparePrice(quantity) {
      var comparisonTotals = state.specialRegion ? { "1": 5999, "2": 9499, "3": 11499 } : { "1": 3999, "2": 7499, "3": 10499 };
      var key = String(quantity);
      var price = kitDisplayPrice(quantity);
      return comparisonTotals[key] > price ? comparisonTotals[key] : price;
    }

    function updatePrices() {
      page.querySelectorAll("[data-quantity]").forEach(function (card) {
        var cardQuantity = Number(card.dataset.quantity || 1);
        var total = card.querySelector("[data-qty-total]");
        var compare = card.querySelector("[data-qty-compare]");
        var kit = kits[String(cardQuantity)];
        if (total) total.textContent = money(kitDisplayPrice(cardQuantity), state.currency);
        card.disabled = !kit || !kit.available;
        if (compare) { var compareTotals = state.specialRegion ? { "1": 5999, "2": 9499, "3": 11499 } : { "1": 3999, "2": 7499, "3": 10499 }; compare.textContent = money(compareTotals[String(cardQuantity)] || state.unitPrice * cardQuantity, state.currency); }
      });

      page.querySelectorAll("[data-vexa-unit-price]").forEach(function (node) {
        node.textContent = money(kitDisplayPrice(state.quantity), state.currency);
      });
      page.querySelectorAll("[data-vexa-unit-compare]").forEach(function (node) {
        node.textContent = money(kitComparePrice(state.quantity), state.currency);
      });
      var heroSaving = page.querySelector(".vc-hero .vc-save-pill");
      if (heroSaving) {
        var heroCompare = kitComparePrice(state.quantity);
        heroSaving.textContent = "Ahorras " + Math.round((1 - kitDisplayPrice(state.quantity) / heroCompare) * 100) + "%";
      }
      page.querySelectorAll("[data-vexa-mobile-price]").forEach(function (node) {
        node.textContent = money(kitDisplayPrice(state.quantity), state.currency);
      });
      page.querySelectorAll("[data-vexa-mobile-compare]").forEach(function (node) {
        node.textContent = "Antes " + money(kitComparePrice(state.quantity), state.currency);
      });
      page.querySelectorAll("[data-vexa-mobile-label]").forEach(function (node) {
        node.textContent = "Kit · " + state.quantity + " unidad" + (state.quantity === 1 ? "" : "es");
      });
      page.querySelectorAll("[data-cod-quantity]").forEach(function (node) {
        node.textContent = String(state.quantity);
      });
      page.querySelectorAll("[data-cod-total]").forEach(function (node) {
        var discount = appliedDiscount && appliedDiscount.variantId === state.variantId ? appliedDiscount.amountCents : 0;
        node.textContent = money(Math.max(0, kitDisplayPrice(state.quantity) - discount), state.currency);
      });
    }

    function chooseQuantity(quantity) {
      if (state.quantity !== Number(quantity)) {
        appliedDiscount = null;
        if (couponStatus && couponInput && couponInput.value.trim()) couponStatus.textContent = "Vuelve a aplicar el cupón para este kit.";
      }
      state.quantity = Math.max(1, Math.min(3, Number(quantity || 1)));
      var selectedKit = kits[String(state.quantity)];
      state.variantId = selectedKit ? String(selectedKit.id) : "";
      state.lineQuantity = 1;
      var kitLabel = page.querySelector("[data-vexa-kit-label]");
      if (kitLabel && selectedKit) kitLabel.textContent = selectedKit.title;
      /* VEXA regional checkout fallback v1 */
      if (state.specialRegion && selectedKit) {
        var regionalParams = new URLSearchParams();
        regionalParams.set("attributes[VEXA - Región]", "Envío especial");
        regionalParams.set("attributes[VEXA - Pago]", "Anticipado");
        regionalParams.set("attributes[VEXA - Envío]", state.quantity === 3 ? "Prioritario gratis" : "Prioritario · 15 €");
        regionalParams.set("note", "Pago online VEXA · Envío especial prioritario");
        var regionalHref = shopPath("cart/" + encodeURIComponent(selectedKit.id) + ":1") + "?" + regionalParams.toString();
        page.querySelectorAll("[data-online-checkout]").forEach(function (node) {
          node.setAttribute("href", regionalHref);
        });
      }
      page.querySelectorAll("[data-quantity]").forEach(function (card) {
        var selected = Number(card.dataset.quantity) === state.quantity;
        card.classList.toggle("is-selected", selected);
        card.setAttribute("aria-checked", selected ? "true" : "false");
      });
      updatePrices();
    }

    page.querySelectorAll("[data-quantity]").forEach(function (card) {
      card.addEventListener("click", function () {
        if (card.disabled || state.submitting) return;
        chooseQuantity(card.dataset.quantity);
        var kit = kits[String(state.quantity)];
        if (kit) {
          publishVexa("vexa_kit_selected", {units:state.quantity,value:kitDisplayPrice(state.quantity) / 100,currency:state.currency});
          metaTrack("CustomizeProduct", {content_type:"product",content_ids:[String(kit.id)],num_items:1,value:kitDisplayPrice(state.quantity) / 100,currency:state.currency});
        }
      });
    });

    page.querySelectorAll("[role='radiogroup']").forEach(function (group) {
      group.addEventListener("keydown", function (event) {
        if (["ArrowLeft", "ArrowRight", "ArrowUp", "ArrowDown", "Home", "End"].indexOf(event.key) === -1) return;
        var cards = Array.prototype.slice.call(group.querySelectorAll("[data-quantity]:not(:disabled)"));
        if (!cards.length) return;
        var current = cards.indexOf(document.activeElement);
        var next = current < 0 ? 0 : current;
        if (event.key === "Home") next = 0;
        else if (event.key === "End") next = cards.length - 1;
        else next = (next + (["ArrowRight", "ArrowDown"].indexOf(event.key) !== -1 ? 1 : -1) + cards.length) % cards.length;
        event.preventDefault();
        cards[next].focus();
        cards[next].click();
      });
    });

    var variantControl = page.querySelector("[data-variant-select]");
    if (variantControl) {
      state.variantId = String(variantControl.value || state.variantId);
      if (variantControl.tagName === "SELECT") {
        variantControl.addEventListener("change", function () {
          var option = variantControl.options[variantControl.selectedIndex];
          state.variantId = String(option.value);
          state.unitPrice = Number(option.dataset.price || state.unitPrice);
          state.comparePrice = Number(option.dataset.compare || option.dataset.price || state.comparePrice);
          updatePrices();
        });
      }
    }

    function openDrawer(trigger) {
      if (!drawer) return;
      if (drawer.classList.contains("is-open")) return;
      lastFocused = trigger || document.activeElement;
      lockedScrollY = window.scrollY || window.pageYOffset || 0;
      document.body.style.top = "-" + lockedScrollY + "px";
      drawer.classList.add("is-open");
      drawer.setAttribute("aria-hidden", "false");
      document.body.classList.add("vc-lock");
      var panel = drawer.querySelector(".vc-drawer-panel");
      if (panel) panel.scrollTop = 0;
      window.setTimeout(function () {
        var firstInput = trigger && trigger.hasAttribute("data-focus-discount") ? couponInput : drawer.querySelector('[name="first_name"]');
        if (state.created) { var heading = drawer.querySelector("[data-success-title]"); if (heading) heading.focus(); }
        else if (firstInput) firstInput.focus({ preventScroll: true });
      }, 30);
    }

    function closeDrawer() {
      if (!drawer || state.submitting) return;
      drawer.classList.remove("is-open");
      drawer.setAttribute("aria-hidden", "true");
      document.body.classList.remove("vc-lock");
      document.body.style.top = "";
      if (typeof window.scrollTo === "function") window.scrollTo(0, lockedScrollY);
      if (lastFocused && typeof lastFocused.focus === "function") lastFocused.focus();
    }

    page.querySelectorAll("[data-cod-open]").forEach(function (button) {
      button.addEventListener("click", function (event) {
        event.preventDefault();
        if (button.disabled) return;
        openDrawer(button);
      });
    });

    page.querySelectorAll("[data-cod-close]").forEach(function (button) {
      button.addEventListener("click", closeDrawer);
    });

    if (drawer) {
      drawer.addEventListener("click", function (event) {
        if (event.target === drawer) closeDrawer();
      });
    }

    document.addEventListener("keydown", function (event) {
      if (!drawer || !drawer.classList.contains("is-open")) return;
      if (event.key === "Escape") {
        event.preventDefault();
        closeDrawer();
        return;
      }
      if (event.key !== "Tab") return;
      var focusable = Array.prototype.slice.call(drawer.querySelectorAll("button:not(:disabled), input:not(:disabled), select:not(:disabled), textarea:not(:disabled), a[href], [tabindex]:not([tabindex='-1'])")).filter(function (node) {
        return node.offsetParent !== null;
      });
      if (!focusable.length) return;
      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });

    async function addToCart(properties) {
      if (!state.variantId) throw new Error("No hay una variante de producto seleccionada.");
      var response = await fetch(shopPath("cart/add.js"), {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({
          items: [
            {
              id: Number(state.variantId),
              quantity: state.lineQuantity,
              properties: properties || {},
            },
          ],
        }),
      });
      var result = await response.json();
      if (!response.ok) throw new Error(result.description || "No pudimos añadir el producto.");
      return result;
    }

    async function beginOnlineCheckout(button) {
      if (state.onlineRedirecting || state.submitting || button.disabled) return;
      state.onlineRedirecting = true;
      var original = button.innerHTML;
      button.disabled = true;
      button.textContent = "Abriendo checkout…";
      try {
        var onlineParams = new URLSearchParams();
        if (!state.specialRegion) onlineParams.set("discount", "ONLINE2");
        onlineParams.set("attributes[VEXA - Pago]", "Online");
        onlineParams.set("attributes[VEXA - Envío]", "Prioritario");
        onlineParams.set("attributes[VEXA - Garantía]", "Devolución del 100% · tramitación inmediata tras aprobación");
        onlineParams.set("properties", "eyJHYXJhbnTDrWEgVkVYQSI6IjEwMCUgZGVsIGRpbmVybyDCtyB0cmFtaXRhY2nDs24gaW5tZWRpYXRhIHRyYXMgYXByb2JhY2nDs24ifQ");
        onlineParams.set("note", "Pago online VEXA · Envío prioritario");
        publishVexa("vexa_checkout_started", {mode:"online",units:state.quantity,currency:state.currency});
        var onlineKit = kits[String(state.quantity)];
        metaTrack("AddToCart", {content_type:"product",content_ids:[String(state.variantId)],num_items:1,value:kitDisplayPrice(state.quantity) / 100,currency:state.currency});
        metaTrack("InitiateCheckout", {content_type:"product",content_ids:[String(state.variantId)],num_items:1,value:kitDisplayPrice(state.quantity) / 100,currency:state.currency});
        window.location.assign(shopPath("cart/" + encodeURIComponent(state.variantId) + ":" + state.lineQuantity) + "?" + onlineParams.toString());
      } catch (error) {
        state.onlineRedirecting = false;
        button.disabled = false;
        button.innerHTML = original;
        window.alert(error.message || "No pudimos abrir el checkout.");
      }
    }

    page.querySelectorAll("[data-online-checkout]").forEach(function (button) {
      button.addEventListener("click", function () {
        beginOnlineCheckout(button);
      });
    });

    async function createDirectCod(payload) {
      var response = await fetch(state.endpoint, {
        method: "POST",
        credentials: "same-origin",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify(payload),
      });
      var result = {};
      try {
        result = await response.json();
      } catch (_error) {
        result = {};
      }
      if (!response.ok || !result.ok) {
        throw new Error(result.error || "No pudimos crear el pedido. Revisa los datos e inténtalo de nuevo.");
      }
      return result;
    }

    if (couponInput) {
      couponInput.addEventListener("input", function () {
        if (appliedDiscount) {
          appliedDiscount = null;
          updatePrices();
        }
        if (couponStatus) {
          couponStatus.className = "";
          couponStatus.textContent = couponInput.value.trim() ? "Pulsa Aplicar para comprobar el código." : "Introduce el código y pulsa Aplicar para ver el nuevo total.";
        }
      });
      var applyCoupon = form.querySelector("[data-cod-apply]");
      if (applyCoupon) applyCoupon.addEventListener("click", async function () {
        var code = couponInput.value.trim().toUpperCase().replace(/\s+/g, "");
        if (!code) { couponInput.focus(); if (couponStatus) couponStatus.textContent = "Introduce un código promocional."; return; }
        if (!state.variantId) { if (couponStatus) couponStatus.textContent = "Selecciona primero un kit."; return; }
        applyCoupon.disabled = true;
        applyCoupon.textContent = "Comprobando…";
        try {
          var verified = await createDirectCod({ action: "validate_discount", variant_id: state.variantId, discount_code: code });
          appliedDiscount = { code: verified.code, amountCents: Math.round(Number(verified.discount_amount) * 100), variantId: state.variantId };
          couponInput.value = verified.code;
          if (couponStatus) { couponStatus.className = "is-valid"; couponStatus.textContent = "Cupón " + verified.code + " aplicado · ahorras " + money(appliedDiscount.amountCents, state.currency) + "."; }
          updatePrices();
        } catch (error) {
          appliedDiscount = null;
          if (couponStatus) { couponStatus.className = "is-error"; couponStatus.textContent = error.message || "No pudimos comprobar el cupón."; }
          updatePrices();
        } finally {
          applyCoupon.disabled = false;
          applyCoupon.textContent = "Aplicar";
        }
      });
    }

    /* VEXA guided COD validation v1 */
    function validationWrapper(control) {
      return control && control.closest ? control.closest(".vc-field, .vc-consent") : null;
    }

    function fieldIsValid(control) {
      if (!control) return true;
      if (control.required && control.type !== "checkbox" && !String(control.value || "").trim()) return false;
      return typeof control.checkValidity !== "function" || control.checkValidity();
    }

    function validationMessage(control) {
      if (control.validity && control.validity.typeMismatch) return "Introduce un correo válido.";
      if (control.validity && control.validity.patternMismatch) return "Introduce un código postal válido de 5 cifras.";
      if (control.type === "checkbox") return "Marca esta casilla para continuar.";
      return "Completa este dato.";
    }

    function clearFieldError(control) {
      var wrapper = validationWrapper(control);
      if (!wrapper) return;
      wrapper.classList.remove("is-invalid");
      control.removeAttribute("aria-invalid");
      var error = wrapper.querySelector(".vc-field-error");
      if (error) {
        control.removeAttribute("aria-describedby");
        error.remove();
      }
    }

    function markFieldError(control) {
      var wrapper = validationWrapper(control);
      if (!wrapper) return;
      wrapper.classList.add("is-invalid");
      control.setAttribute("aria-invalid", "true");
      var error = wrapper.querySelector(".vc-field-error");
      if (!error) {
        error = document.createElement("small");
        error.className = "vc-field-error";
        error.id = "vc-error-" + (control.name || "field").replace(/[^a-z0-9_-]/gi, "-");
        wrapper.appendChild(error);
      }
      error.textContent = validationMessage(control);
      control.setAttribute("aria-describedby", error.id);
    }

    function guideToFirstInvalid() {
      var requiredControls = Array.prototype.slice.call(form.querySelectorAll("input[required], select[required], textarea[required]"));
      var invalidControls = requiredControls.filter(function (control) {
        if (fieldIsValid(control)) {
          clearFieldError(control);
          return false;
        }
        markFieldError(control);
        return true;
      });
      if (!invalidControls.length) return true;

      var firstInvalid = invalidControls[0];
      var target = validationWrapper(firstInvalid) || firstInvalid;
      var reduceMotion = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
      if (target.scrollIntoView) target.scrollIntoView({ behavior: reduceMotion ? "auto" : "smooth", block: "center" });
      try { firstInvalid.focus({ preventScroll: true }); }
      catch (_error) { firstInvalid.focus(); }
      return false;
    }

    /* VEXA clear guided error on correction v1 */
    if (form) {
      ["input", "change"].forEach(function (eventName) {
        form.addEventListener(eventName, function (event) {
          var control = event.target;
          if (!control || !control.matches || !control.matches("input[required], select[required], textarea[required]")) return;
          if (fieldIsValid(control)) clearFieldError(control);
        });
      });
    }
    if (form) {
      form.addEventListener("submit", async function (event) {
        event.preventDefault();
        status.className = "vc-form-status";
        status.textContent = "";

        if (!guideToFirstInvalid()) {
          setStatus(status, "Revisa el campo marcado en rojo.", "error");
          return;
        }
        if (!state.variantId) {
          setStatus(status, "Selecciona el producto Candela en Shopify antes de recibir pedidos.", "error");
          return;
        }        if (state.submitting || state.created) return;
        setCodBusy(true);
        if (!state.requestId) state.requestId = window.crypto.randomUUID();
        var submitButton = form.querySelector("[data-cod-submit]");
        var submitLabel = submitButton.textContent;
        submitButton.disabled = true;
        submitButton.textContent = "Creando pedido…";

        var formData = new FormData(form);
        var values = Object.fromEntries(formData.entries());
        /* VEXA mainland-only checkout guard v1 */
        var normalizedLocation = [values.province, values.city, values.address1, values.address2].join(" ")
          .normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();
        var postalPrefix = String(values.zip || "").replace(/\D/g, "").slice(0, 2);
        var excludedPostalPrefixes = ["07", "35", "38", "51", "52"];
        var excludedDeliveryTerms = [
          "baleares", "illes balears", "islas baleares", "mallorca", "menorca", "ibiza", "eivissa", "formentera",
          "canarias", "islas canarias", "tenerife", "gran canaria", "lanzarote", "fuerteventura",
          "la gomera", "el hierro", "la graciosa", "ceuta", "melilla"
        ];
        var excludedDeliveryArea = excludedPostalPrefixes.indexOf(postalPrefix) !== -1 ||
          excludedDeliveryTerms.some(function (term) { return normalizedLocation.indexOf(term) !== -1; });
        if (excludedDeliveryArea) {
          setStatus(status, "Solo realizamos envíos a España peninsular. No enviamos a islas, Ceuta ni Melilla.", "error");
                    setCodBusy(false);
          submitButton.textContent = submitLabel;
          return;
        }
        try {
          var codKit = kits[String(state.quantity)];
          metaTrack("InitiateCheckout", {content_type:"product",content_ids:[String(state.variantId)],num_items:1,value:(codKit ? codKit.price : state.unitPrice * state.quantity) / 100,currency:state.currency});
          var result = await createDirectCod({
            idempotency_key: state.requestId,
            variant_id: state.variantId,
            quantity: state.lineQuantity,
            units_per_kit: state.quantity,
            first_name: values.first_name,
            last_name: values.last_name,
            phone: values.phone,
            email: values.email,
            address1: values.address1,
            address2: values.address2 || "",
            province: values.province,
            city: values.city,
            zip: values.zip,
            country_code: state.countryCode,
            currency: state.currency,
            discount_code: values.discount_code || ""
          });
          state.created = true;
          drawer.classList.add("is-success-locked");
          formView.hidden = true;
          successState.classList.add("is-visible");
          var orderName = result.order_name || ("#" + result.order_id);
          if (successMessage) successMessage.textContent = "Tu pedido " + orderName + " se ha creado por " + money(Math.round(Number(result.total_price || 0) * 100), result.currency || state.currency) + (result.discount_code ? " con el cupón " + result.discount_code : "") + ". Lo pagarás al recibir.";
          var whatsapp = page.querySelector("[data-order-whatsapp]");
          if (whatsapp) {
            whatsapp.hidden = false;
            whatsapp.href = "https://wa.me/34624400312?text=" + encodeURIComponent("Hola VEXA, quiero consultar el estado de mi pedido " + orderName + ". ¿Ya está confirmado y en proceso de envío? Muchas gracias.");
          }
          metaTrack("Purchase", {content_type:"product",content_ids:[String(state.variantId)],num_items:1,value:Number(result.total_price || 0),currency:result.currency || state.currency}, "vexa_order_" + String(result.order_id));
          publishVexa("vexa_cod_order_created", {delivery_region:"peninsula",order_id:result.order_id,order_name:orderName,variant_id:state.variantId,units:state.quantity,quantity:1,total:Number(result.total_price || 0),value:Number(result.total_price || 0),currency:result.currency || state.currency});
          window.setTimeout(function () { var heading = page.querySelector("[data-success-title]"); if (heading) heading.focus(); }, 30);
          return;
        } catch (checkoutError) {
          setStatus(status, checkoutError.message || "No pudimos crear el pedido.", "error");
                    setCodBusy(false);
          submitButton.textContent = submitLabel;
          return;
        }

        var payload = {
          idempotency_key: state.requestId,
          variant_id: state.variantId,
          quantity: state.lineQuantity,
          units_per_kit: state.quantity,
          first_name: values.first_name,
          last_name: values.last_name,
          phone: values.phone,
          address1: values.address1,
          address2: values.address2 || "",
          province: values.province,
          city: values.city,
          zip: values.zip || "",
          email: values.email,
          country_code: state.countryCode,
          currency: state.currency,
          source: "VEXA Candela COD",
        };

        try {
          if (state.directCod) {
            var result = await createDirectCod(payload);
            if (!result.order_name || !result.order_id) throw new Error("No pudimos verificar el número del pedido. Contacta con VEXA antes de volver a solicitarlo.");
            state.created = true;
            if (result.total_price != null && Number.isFinite(Number(result.total_price)) && result.currency) {
              publishVexa("vexa_cod_order_created", {delivery_region:"peninsula",order_id:result.order_id,order_name:result.order_name,variant_id:state.variantId,units:state.quantity,quantity:1,total:Number(result.total_price),value:Number(result.total_price),currency:result.currency});
            }
            if (formView) formView.style.display = "none";
            if (successMessage) {
              successMessage.textContent = "Tu pedido " + (result.order_name || "") + " quedó creado en Shopify y lo pagarás al recibir.";
            }
            var whatsapp = page.querySelector("[data-order-whatsapp]");
            if (whatsapp) { whatsapp.href = "https://wa.me/34624400312?text=" + encodeURIComponent("Hola VEXA, quiero saber el estado de mi orden " + String(result.order_name) + ". ¿Ya está confirmada y en proceso de envío? Muchas gracias."); whatsapp.hidden = false; }
            if (successState) successState.classList.add("is-visible");
            var successTitle = page.querySelector("[data-success-title]");
            if (successTitle) successTitle.focus();
          } else {
            throw new Error("La creación automática de pedidos todavía no está activa.");
          }
        } catch (error) {
          setStatus(status, error.message || "Ha ocurrido un error. Inténtalo de nuevo.", "error");
                    setCodBusy(false);
          submitButton.textContent = submitLabel;
        }
      });
    }

    chooseQuantity(1);
    page.querySelectorAll("[data-cod-help], [data-order-whatsapp]").forEach(function (link) {
      link.addEventListener("click", function () {
        publishVexa("vexa_whatsapp_clicked", {});
        metaTrack("Contact", {content_name:"WhatsApp VEXA",content_category:"support"});
      });
    });
    if (kits["1"] && window.location.pathname && window.location.pathname.indexOf("/products/") === -1) {
      publishVexa("vexa_product_viewed", {variant_id:kits["1"].id,value:kitDisplayPrice(1) / 100,currency:state.currency});
      metaTrack("ViewContent", {content_type:"product",content_ids:[String(kits["1"].id)],value:kitDisplayPrice(1) / 100,currency:state.currency});
    }
  }

  function init() {
    document.querySelectorAll("[data-vexa-page]").forEach(initVexaPage);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();



;(function () {
  "use strict";
  function applyRevealMotion(page) {
    var reduceMotion = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (reduceMotion || !("IntersectionObserver" in window)) return;
    var selectors = [
      ".vc-hero-copy > *", ".vc-hero-media", ".vc-qty-card", ".vc-purchase-panel", ".vc-proof-item", ".vc-media-card", ".vc-reviews-head > *", ".vc-lifestyle-media", ".vc-lifestyle-copy > *", ".vc-section > .vc-shell > .vc-eyebrow", ".vc-section > .vc-shell > .vc-section-title", ".vc-evaluation-grid > *", ".vc-bento-card", ".vc-root-sticky > *", ".vc-cycle-step", ".vc-reframe > *", ".vc-ritual-card", ".vc-claim-card", ".vc-comparison-table", ".vc-faq-grid > *", ".vc-guides-grid > *", ".vc-final > *", ".vc-footer-inner > *"
    ].join(",");
    var nodes = Array.prototype.slice.call(page.querySelectorAll(selectors));
    if (!nodes.length) return;
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add("is-visible");
        observer.unobserve(entry.target);
      });
    }, { rootMargin: "0px 0px -7% 0px", threshold: 0.06 });
    var index = 0;
    var scheduleFrame = window.requestAnimationFrame || function (callback) { return window.setTimeout(callback, 16); };
    function prepareRevealBatch() {
      var end = Math.min(index + 12, nodes.length);
      for (; index < end; index += 1) {
        var node = nodes[index];
        node.classList.add("vc-reveal");
        if (node.matches(".vc-use-product,.vc-lifestyle-media")) node.classList.add("vc-reveal--left");
        if (node.matches(".vc-hero-media,.vc-use-copy")) node.classList.add("vc-reveal--right");
        node.style.setProperty("--vc-reveal-delay", String((index % 4) * 75) + "ms");
      }
      if (index < nodes.length) {
        scheduleFrame(prepareRevealBatch);
        return;
      }
      document.documentElement.classList.add("vc-motion-ready");
      nodes.forEach(function (node) { observer.observe(node); });
    }
    if (typeof window.requestIdleCallback === "function") {
      window.requestIdleCallback(function () { scheduleFrame(prepareRevealBatch); }, { timeout: 1200 });
    } else {
      window.setTimeout(function () { scheduleFrame(prepareRevealBatch); }, 0);
    }
  }
  function initReveal() { document.querySelectorAll("[data-vexa-page]").forEach(applyRevealMotion); }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", initReveal);
  else initReveal();
})();

/* VEXA CRO draft v1 - start */
(function () {
  function initCtaFallback() {
    var page = document.querySelector('[data-vexa-page]');
    if (!page || page.dataset.croDraftReady === 'true') return;
    page.dataset.croDraftReady = 'true';

    page.addEventListener('click', function (event) {
      var trigger = event.target.closest('a[href="#oferta"], .vc-nav-cta, .vc-mobile-buy a');
      if (!trigger || !page.contains(trigger)) return;
      var offer = page.querySelector('#oferta');
      if (!offer) return;
      var target = offer.querySelector('.vc-kit-heading') || offer.querySelector('.vc-quantity-grid') || offer;
      event.preventDefault();
      target.scrollIntoView({
        behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
        block: 'start'
      });
      window.history.replaceState(null, '', '#oferta');
      var quantityGrid = offer.querySelector('.vc-quantity-grid');
      if (quantityGrid) {
        quantityGrid.classList.remove('vc-cro-focus');
        void quantityGrid.offsetWidth;
        quantityGrid.classList.add('vc-cro-focus');
        window.setTimeout(function () { quantityGrid.classList.remove('vc-cro-focus'); }, 850);
      }
    });

    page.addEventListener('keydown', function (event) {
      var card = event.target.closest('[data-quantity]');
      if (!card || !page.contains(card)) return;
      var cards = Array.prototype.slice.call(page.querySelectorAll('[data-quantity]:not([disabled])'));
      var currentIndex = cards.indexOf(card);
      if (event.key === 'ArrowRight' || event.key === 'ArrowDown') {
        event.preventDefault();
        cards[(currentIndex + 1) % cards.length].click();
        cards[(currentIndex + 1) % cards.length].focus();
      } else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') {
        event.preventDefault();
        cards[(currentIndex - 1 + cards.length) % cards.length].click();
        cards[(currentIndex - 1 + cards.length) % cards.length].focus();
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCtaFallback, { once: true });
  } else {
    initCtaFallback();
  }
})();
/* VEXA CRO draft v1 - end */

/* VEXA COD header overlap fix v1 - start */
(function () {
  var page = document.querySelector('[data-vexa-page]');
  if (!page || page.dataset.codHeaderFixReady === 'true') return;
  page.dataset.codHeaderFixReady = 'true';

  page.addEventListener('click', function (event) {
    if (!event.target.closest('[data-cod-open]')) return;
    var panel = page.querySelector('.vc-drawer-panel');
    if (!panel) return;
    window.setTimeout(function () { panel.scrollTop = 0; }, 0);
  });
})();
/* VEXA COD header overlap fix v1 - end */
/* VEXA daily offer countdown v1 */
(function () {
  var zone = "Europe/Madrid";
  var formatter = new Intl.DateTimeFormat("en-CA", {
    timeZone: zone,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hourCycle: "h23"
  });

  function partsAt(date) {
    var values = {};
    formatter.formatToParts(date).forEach(function (part) {
      if (part.type !== "literal") values[part.type] = Number(part.value);
    });
    return values;
  }

  function madridLocalToUtc(year, month, day, hour, minute, second) {
    var targetAsUtc = Date.UTC(year, month - 1, day, hour, minute, second);
    var guess = targetAsUtc;
    for (var index = 0; index < 3; index += 1) {
      var rendered = partsAt(new Date(guess));
      var renderedAsUtc = Date.UTC(rendered.year, rendered.month - 1, rendered.day, rendered.hour, rendered.minute, rendered.second);
      guess += targetAsUtc - renderedAsUtc;
    }
    return guess;
  }

  function nextMadridMidnight(now) {
    var current = partsAt(now);
    var tomorrow = new Date(Date.UTC(current.year, current.month - 1, current.day + 1));
    return madridLocalToUtc(tomorrow.getUTCFullYear(), tomorrow.getUTCMonth() + 1, tomorrow.getUTCDate(), 0, 0, 0);
  }

  function twoDigits(value) {
    return String(value).padStart(2, "0");
  }


  function updateCountdown() {
    var now = new Date();
    if (!updateCountdown.cachedMadridMidnight || now.getTime() >= updateCountdown.cachedMadridMidnight) {
      updateCountdown.cachedMadridMidnight = nextMadridMidnight(now);
    }
    var midnight = updateCountdown.cachedMadridMidnight;
    var remaining = Math.max(0, Math.ceil((midnight - now.getTime()) / 1000));
    var hours = Math.floor(remaining / 3600);
    var minutes = Math.floor((remaining % 3600) / 60);
    var seconds = remaining % 60;
    var value = twoDigits(hours) + ":" + twoDigits(minutes) + ":" + twoDigits(seconds);
    var countdownNode = updateCountdown.countdownNode || (updateCountdown.countdownNode = document.querySelector("[data-vexa-daily-countdown]"));
    if (countdownNode) {
      countdownNode.textContent = value;
      countdownNode.setAttribute("datetime", "PT" + hours + "H" + minutes + "M" + seconds + "S");
    }
  }

  function initDailyOffer() {
    if (!document.querySelector("[data-vexa-daily-offer]")) return;
    updateCountdown();
    var countdownTimer = 0;
    function scheduleCountdown() {
      if (countdownTimer) window.clearTimeout(countdownTimer);
      if (document.hidden) return;
      countdownTimer = window.setTimeout(function () {
        updateCountdown();
        scheduleCountdown();
      }, 1000);
    }
    document.addEventListener("visibilitychange", function () {
      if (document.hidden) {
        if (countdownTimer) window.clearTimeout(countdownTimer);
        countdownTimer = 0;
      } else {
        updateCountdown();
        scheduleCountdown();
      }
    });
    scheduleCountdown();
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", initDailyOffer);
  else initDailyOffer();
})();
/* VEXA business-day delivery estimate v1 */
(function () {
  var zone = "Europe/Madrid";
  var dateParts = new Intl.DateTimeFormat("en-CA", {
    timeZone: zone,
    year: "numeric",
    month: "2-digit",
    day: "2-digit"
  });
  var dateLabel = new Intl.DateTimeFormat("es-ES", {
    timeZone: "UTC",
    weekday: "long",
    day: "numeric",
    month: "long"
  });

  function madridDate(now) {
    var values = {};
    dateParts.formatToParts(now).forEach(function (part) {
      if (part.type !== "literal") values[part.type] = Number(part.value);
    });
    return new Date(Date.UTC(values.year, values.month - 1, values.day, 12));
  }

  function isBusinessDay(date) {
    var day = date.getUTCDay();
    return day !== 0 && day !== 6;
  }

  function arrivalDate(days, inclusiveToday) {
    var date = madridDate(new Date());
    var remaining = Math.max(1, Number(days) || 1);
    if (inclusiveToday && isBusinessDay(date)) remaining -= 1;
    while (remaining > 0) {
      date.setUTCDate(date.getUTCDate() + 1);
      if (isBusinessDay(date)) remaining -= 1;
    }
    return date;
  }

  function capitalize(value) {
    return value.charAt(0).toUpperCase() + value.slice(1);
  }

  function updateDeliveryDates() {
    document.querySelectorAll("[data-vexa-delivery-estimate]").forEach(function (notice) {
      var target = notice.querySelector("[data-vexa-arrival-date]");
      if (!target) return;
      var days = Number(notice.getAttribute("data-delivery-days") || 2);
      var inclusive = notice.getAttribute("data-delivery-inclusive") === "true";
      target.textContent = capitalize(dateLabel.format(arrivalDate(days, inclusive)));
    });
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", updateDeliveryDates);
  else updateDeliveryDates();
  document.addEventListener("visibilitychange", function () {
    if (!document.hidden) updateDeliveryDates();
  });
})();


/* Candela Black Friday y calendario VIP 2026 */
(function(){
  "use strict";
  var bfEnd=Date.parse("2026-11-28T00:00:00+01:00");
  var vipEnd=Date.parse("2026-12-01T00:00:00+01:00");
  var calendarIdeas=[
    "Prepara tu espacio", "Rutina de 3 minutos", "Cuánta crema usar", "Masaje suave", "Hidratación diaria", "Escucha tu piel", "Descanso sin culpa", "Texturas y luz", "Rutina de mañana", "Rutina de noche", "Cupón VIP: kit 2 −7 €", "Prueba en zona pequeña", "Masaje circular", "Movimiento amable", "Cómo registrar tu rutina", "Piel sensible: cuidados", "Cupón VIP: kit 2 −8 €", "Qué evitar al aplicar", "Constancia flexible", "Cuida tus manos", "Revisión sin obsesión", "Cupón VIP: kit 3 −15 €", "Rutina de viaje", "Masaje de 5 minutos", "Cuidados tras la ducha", "Preguntas frecuentes", "Mega oferta Black Friday", "Descansa y retoma", "Tu ritual favorito", "Mega oferta Cyber Monday"
  ];
  function two(n){return String(n).padStart(2,"0")}
  function renderCalendar(){var grid=document.querySelector("[data-vip-calendar]");if(!grid)return;var frag=document.createDocumentFragment();calendarIdeas.forEach(function(idea,index){var day=index+1;var cell=document.createElement("div");cell.className="vc-vip-day"+(day===11||day===17||day===22?" vc-vip-day--coupon":"")+(day===27||day===30?" vc-vip-day--mega":"");var date=document.createElement("strong");date.textContent=two(day)+" NOV";var text=document.createElement("span");text.textContent=idea;cell.append(date,text);frag.appendChild(cell)});grid.appendChild(frag)}
  function update(){var left=Math.max(0,bfEnd-Date.now());var parts=[Math.floor(left/86400000),Math.floor(left/3600000)%24,Math.floor(left/60000)%60,Math.floor(left/1000)%60];["days","hours","minutes","seconds"].forEach(function(name,i){var node=document.querySelector("[data-bf-"+name+"]");if(node)node.textContent=two(parts[i])});if(left>0)return;document.querySelectorAll("[data-cod-open],[data-cod-submit],[data-bf-kit]").forEach(function(button){button.hidden=true;button.disabled=true});var intro=document.querySelector(".vc-bf__intro");if(intro)intro.textContent="La campaña Black Friday ha terminado. Puedes seguir comprando Candela con pago online.";var form=document.querySelector("[data-cod-form]");if(form)form.hidden=true;var drawer=document.querySelector("[data-cod-drawer]");if(drawer&&drawer.getAttribute("aria-hidden")==="false"){var close=drawer.querySelector("[data-cod-close]");if(close)close.click()}}
  function initPopup(){var pop=document.querySelector("[data-vip-popup]");if(!pop||Date.now()>=vipEnd)return;var previous=document.activeElement;window.setTimeout(function(){if(Date.now()>=vipEnd)return;pop.hidden=false;var close=pop.querySelector(".vc-vip-pop__close");if(close)close.focus()},7000);function dismiss(){pop.hidden=true;if(previous&&previous.focus)previous.focus()}pop.querySelectorAll("[data-vip-close]").forEach(function(button){button.addEventListener("click",dismiss)});pop.addEventListener("keydown",function(e){if(e.key==="Escape")dismiss()})}
  function init(){renderCalendar();update();window.setInterval(update,1000);document.querySelectorAll("[data-bf-kit]").forEach(function(button){button.addEventListener("click",function(){if(Date.now()>=bfEnd)return;var page=document.querySelector("[data-vexa-page]");if(!page)return;var selected=page.querySelector('.vc-quantity-grid [data-quantity="'+button.getAttribute("data-bf-kit")+'"]');if(selected)selected.click();var cod=page.querySelector(".vc-purchase-actions [data-cod-open]");if(cod)cod.click()})});initPopup();document.addEventListener("submit",function(e){if(Date.now()>=bfEnd&&e.target&&e.target.matches("[data-cod-form]")){e.preventDefault();e.stopImmediatePropagation();update()}},true)}
  if(document.readyState==="loading")document.addEventListener("DOMContentLoaded",init);else init();
})();
